/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["sidebar-action-buttons{display:block;text-align:center}sidebar-action-buttons mat-icon{vertical-align:unset!important}sidebar-action-buttons button[disabled]{color:#6c757d!important}sidebar-action-buttons .new-folder-button{max-width:60px;min-width:auto}"];
export { styles as styles };
